





































































































































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

export default Vue.extend({
  name: 'Process',

  data: () => ({
    valence: {
      min: 0,
      max: 1,
      label: 'Happiness',
      val: 1,
      color: 'rgb(255, 196, 1)',
    },
    energy: {
      min: 0,
      max: 1,
      label: 'Energy',
      val: 1,
      color: 'rgb(1, 162, 255)',
    },
    danceability: {
      min: 0,
      max: 1,
      label: 'Danceability',
      val: 1,
      color: 'rgb(187, 74, 253)',
    },
    acousticness: {
      min: 0,
      max: 1,
      label: 'Acousticness',
      val: 1,
      color: 'rgb(248, 91, 91)',
    },
    liveness: {
      min: 0,
      max: 1,
      label: 'Liveness',
      val: 1,
      color: 'rgb(159, 255, 121)',
    },
    speechiness: {
      min: 0,
      max: 1,
      label: 'Speechiness',
      val: 1,
      color: 'rgb(255, 82, 241)',
    },
    instrumentalness: {
      min: 0,
      max: 1,
      label: 'Instrumentalness',
      val: 1,
      color: 'rgb(65, 255, 214)',
    },
    tempo: {
      min: 0,
      max: 1,
      label: 'Tempo',
      val: 1,
      color: 'rgb(240, 124, 70)',
    },
    popularity: {
      min: 0,
      max: 1,
      label: 'Popularity',
      val: 1,
      color: 'rgb(230, 245, 100)',
    },
  }),

  computed: {
    ...mapGetters('preferences', [
      'getValenceWeight',
      'getEnergyWeight',
      'getDanceabilityWeight',
      'getAcousticnessWeight',
      'getLivelinessWeight',
      'getSpeechinessWeight',
      'getInstrumentalnessWeight',
      'getTempoWeight',
      'getPopularityWeight',
    ]),

    ...mapGetters('map', [
      'isProcessDone',
    ]),

    disableSliders() {
      if (!this.isProcessDone) {
        return true;
      }
      return false;
    },
  },

  created() {
    this.valence.val = this.getValenceWeight;
    this.energy.val = this.getEnergyWeight;
    this.danceability.val = this.getDanceabilityWeight;
    this.acousticness.val = this.getAcousticnessWeight;
    this.liveness.val = this.getLivelinessWeight;
    this.speechiness.val = this.getSpeechinessWeight;
    this.instrumentalness.val = this.getInstrumentalnessWeight;
    this.tempo.val = this.getTempoWeight;
    this.popularity.val = this.getPopularityWeight;
  },

  methods: {
    ...mapActions('preferences', [
      'setWeights',
    ]),

    changeSettings() {
      this.setWeights({
        valenceWeight: this.valence.val,
        energyWeight: this.energy.val,
        danceabilityWeight: this.danceability.val,
        acousticnessWeight: this.acousticness.val,
        livenessWeight: this.liveness.val,
        speechinessWeight: this.speechiness.val,
        instrumentalnessWeight: this.instrumentalness.val,
        tempoWeight: this.tempo.val,
        popularityWeight: this.popularity.val,
      });
    },
  },
});
